/**
* Request for plan creation.
*/
export interface PlanRequest {
	patientGuid: string;
	number: string;
	device: DeviceEnum;
	boneType: BoneTypeEnum;
	side: AnatomicalSideEnum;
	type: string;
	referenceType: ReferenceTypeEnum;
	isPostOperative: boolean;
	notes?: string | null;
	apImageGuid?: string;
	ltImageGuid?: string;
}

export enum AnatomicalSideEnum {
	Left = 'Left',
	Right = 'Right'
}

export enum BoneTypeEnum {
	LongLeg = 'Long Leg',
	Femur = 'Femur',
	Tibia = 'Tibia',
	Ankle = 'Ankle',
	Forefoot = 'Forefoot',
	Hindfoot = 'Hindfoot'
}

export enum ReferenceTypeEnum {
	Proximal = 'Proximal',
	Distal = 'Distal'
}

export enum BoneViewEnum {
	AP = 'AP',
	LAT = 'LAT'
}

export enum PlanTypeEnum {
	Deformity = 'Deformity',
	Fracture = 'Fracture'
}

export enum DeviceEnum {
	ToBeDefined = 'ToBeDefined',
	Fitbone = 'Fitbone',
	Jps = 'Jps',
	Tlhex = 'Tlhex'
}

export enum PlanStepEnum {
	None = 'None',
	Deformity = 'Deformity',
	EOC = 'EOC',
	Templating = 'Templating',
	RPM = 'RPM',
	Mounting = 'Mounting',
	Schedule = 'Schedule',
	Report = 'Report',
	Adjust = 'Adjust'
}
